<script setup>
import DemandForm from '@/Pages/Contacts/Partials/DemandForm.vue'
import { DevicePhoneMobileIcon, EnvelopeOpenIcon } from '@heroicons/vue/24/solid'

defineProps({
    demand_types: {
        type: Array,
        required: true,
    },

    demand_of_constructions: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <section
        id="kontakt"
        aria-label="Programátorské akce zaměřené na Laravel, Inertia.js, Vue.js a Tailwind CSS"
        class="scroll-mt-32"
    >
        <header class="header-width">
            <h2 class="header-h">Kontaktujte nás</h2>
        </header>

        <div class="mt-5 flex flex-col gap-16 sm:gap-y-20 lg:mt-10 xl:flex-row">
            <DemandForm
                :demand_types="demand_types"
                :demand_of_constructions="demand_of_constructions"
            />

            <div class="flex flex-col items-center justify-center gap-3 lg:flex-row xl:flex-col">
                <address
                    v-for="contact in $page.props.contacts"
                    :key="contact.name"
                    class="mb-2 flex w-full cursor-default flex-col items-center justify-center space-y-4 rounded-xl bg-white p-6 not-italic shadow-xs shadow-gray-200 md:flex-row lg:flex-col lg:divide-x-0"
                >
                    <div class="w-full text-center">
                        <div class="text-center text-xl font-semibold">
                            <span class="text-brand-orange">{{ contact.name }}</span>
                        </div>
                    </div>

                    <div class="mx-auto flex w-8/12 flex-row items-center justify-between xl:w-full">
                        <div class="mr-4 w-fit">
                            <EnvelopeOpenIcon class="text-brand-orange size-12" />
                        </div>
                        <div class="w-full">
                            <a
                                :href="'mailto:' + contact.email"
                                aria-label="Odeslat email na {{ contact.email }}"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="hover:underline"
                            >
                                {{ contact.email }}
                            </a>
                        </div>
                    </div>

                    <div class="mx-auto flex w-8/12 flex-row items-center justify-between xl:w-full">
                        <div class="mr-4 w-fit">
                            <DevicePhoneMobileIcon class="text-brand-orange size-12" />
                        </div>
                        <div class="w-full">
                            <a
                                :href="'tel:' + contact.phone"
                                aria-label="Zavolat na telefonní číslo {{ contact.phone }}"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="hover:underline"
                            >
                                {{ contact.phone }}
                            </a>
                        </div>
                    </div>
                </address>
            </div>
        </div>
    </section>
</template>
